import React from 'react'

import SalesEventsForm from 'components/SalesEvents/Form'
import Layout from 'components/Layout'

const SalesEventsDetails = () => {
  return <Layout mainContent={<SalesEventsForm />} />
}

export default SalesEventsDetails
